import React from 'react';
import { BrowserRouter, Switch, Route } from 'react-router-dom';

import DefaultRoutes from '../layouts/Defaultroutes';
import PrivateRoutes from '../layouts/Privateroutes';
import Notfound from '../views/NotFound/NotFound';
import Login from '../views/Login/index';
import EsqueciSenha from '../views/EsqueciSenha';
import Home from '../views/Home/index'
import Campanhas from '../views/Campanhas'
import Treinamentos from '../views/Treinamentos'
import Vitrine from '../views/Vitrine'
import DetalheVitrine from '../views/Vitrine/Detalhes'
import GaleriaVitrine from '../views/Galeria'
import DetalheGaleriaVitrine from '../views/Galeria/Detalhes'

import Detalhes from '../views/Campanhas/Detalhes'
import TreinamentoDetalhes from '../views/Treinamentos/Detalhes'
import AdicionarCampanha from '../views/AdicionarCampanha';
import AdicionarTreinamento from '../views/Treinamentos/Adicionar';
import ImportarParticipantesTreinamento from '../views/Treinamentos/Importar';
import Relatorios from '../views/Relatorios';
import { default as DesempenhoDetalhes } from '../views/Desempenho/Detalhes';
import Desempenho from '../views/Desempenho';
import { default as AdministradoresDetalhes } from '../views/Administradores/Detalhes';
import Resultados from '../views/Resultados';
import Administradores from '../views/Administradores';
import Quiz from '../views/Quiz';
import QuizDetalhe from '../views/Quiz/Detalhes';
import ResultadosQuiz from '../views/Quiz/Resultados';
import Faq from '../views/Faq';
import FaqDetalhe from '../views/Faq/Detalhes';
import Regulamento from '../views/Regulamento';
import { default as ResponsaveisDetalhes } from '../views/Responsaveis/Detalhes';
import Responsaveis from '../views/Responsaveis';

import Parceiros from '../views/Parceiros';
import { default as ParceirosDetalhes } from '../views/Parceiros/Detalhes';
import { default as ParceirosImportar } from '../views/Parceiros/Importar';
import { default as ResponsaveisImportar } from '../views/Responsaveis/Importar';

import Participantes from '../views/Participantes';

import Banner from '../views/Banner';
import { default as BannerDetalhes } from '../views/Banner/Detalhes';

import Conteudo from '../views/Conteudo';
import { default as ConteudoDetalhes } from '../views/Conteudo/Detalhes';

import Noticias from '../views/Noticias';
import { default as NoticiasDetalhes } from '../views/Noticias/Detalhes';
import MeuCadastro from '../views/MeuCadastro';

import PopUp from '../views/PopUp';
import PopUpDetalhe from '../views/PopUp/Detalhes';

import services from '../services'
import FaleConosco from '../views/FaleConosco/Lista'; 

export default () => {

    const user = services.storage.getUser();

    return (
        <BrowserRouter>
            <Switch>
                <Route path='/' exact component={Login} />
                <Route path='/esqueci-senha' exact component={EsqueciSenha} />
                <PrivateRoutes path='/home' exact component={Home} />
                <PrivateRoutes path='/campanhas' exact component={Campanhas} />
                <PrivateRoutes path='/treinamentos' exact component={Treinamentos} />
                <PrivateRoutes path='/responsaveis' exact component={Responsaveis} />
                <PrivateRoutes path='/responsaveis/detalhes' exact component={ResponsaveisDetalhes} />
                <PrivateRoutes path='/campanhas/adicionar' exact component={AdicionarCampanha} />
                <PrivateRoutes path='/campanhas/detalhes' exact component={Detalhes} />
                <PrivateRoutes path='/treinamentos/adicionar' exact component={AdicionarTreinamento} />
                <PrivateRoutes path='/treinamentos/importar' exact component={ImportarParticipantesTreinamento} />
                <PrivateRoutes path='/treinamentos/detalhes' exact component={TreinamentoDetalhes} />
                <PrivateRoutes path='/quiz' exact component={Quiz} />
                <PrivateRoutes path='/quiz/detalhe' exact component={QuizDetalhe} />
                <PrivateRoutes path='/quiz/resultados' exact component={ResultadosQuiz} />
                <PrivateRoutes path='/vitrine' exact component={Vitrine} />
                <PrivateRoutes path='/vitrine/detalhe' exact component={DetalheVitrine} />

                <PrivateRoutes path='/conteudo' exact component={Conteudo} />
                <PrivateRoutes path='/conteudo/detalhes' exact component={ConteudoDetalhes} />

                <PrivateRoutes path='/noticias' exact component={Noticias} />
                <PrivateRoutes path='/noticias/detalhes' exact component={NoticiasDetalhes} />

                <PrivateRoutes path='/banner' exact component={Banner} />
                <PrivateRoutes path='/banner/detalhes' exact component={BannerDetalhes} />

                <PrivateRoutes path='/faq' exact component={Faq} />
                <PrivateRoutes path='/faq/detalhe' exact component={FaqDetalhe} />
                <PrivateRoutes path='/regulamento' exact component={Regulamento} />

                <PrivateRoutes path='/meu-cadastro' exact component={MeuCadastro} />

                <PrivateRoutes path='/relatorios' exact component={Relatorios} />
                <PrivateRoutes path='/desempenho/detalhes/:id' exact component={DesempenhoDetalhes} />
                <PrivateRoutes path='/administradores/detalhes/' exact component={AdministradoresDetalhes} />
                <PrivateRoutes path='/desempenho' exact component={Desempenho} />
                <PrivateRoutes path='/galeria-vitrine' exact component={GaleriaVitrine} allow={['Gerente de Relacionamento', 'Gerente de Filial', 'Superintendente']} />
                <PrivateRoutes path='/galeria-vitrine/detalhe' exact component={DetalheGaleriaVitrine} allow={['Gerente de Relacionamento', 'Gerente de Filial', 'Superintendente']} />

                <PrivateRoutes path='/administradores' exact component={Administradores} />
                <PrivateRoutes path='/resultados' exact component={Resultados} /> 

                <PrivateRoutes path='/parceiros' exact component={Parceiros} />
                <PrivateRoutes path='/parceiros/detalhes' exact component={ParceirosDetalhes} />
                <PrivateRoutes path='/parceiros/importar' exact component={ParceirosImportar} />
                <PrivateRoutes path='/responsaveis/importar' exact component={ResponsaveisImportar} />


                <PrivateRoutes path='/participantes' exact component={Participantes} />
                <PrivateRoutes path='/pop-up' exact component={PopUp} />
                <PrivateRoutes path='/pop-up/detalhe' exact component={PopUpDetalhe} />
                <PrivateRoutes path='/fale-conosco' exact component={FaleConosco} />
                <DefaultRoutes component={Notfound} />
            </Switch>
        </BrowserRouter>
    )
};
